import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/organization-types/new/loading';

export const Route = createFileRoute('/_private/settings/organization-types/new')({
  component: Loading,
});
